import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className='navbar fixed top-0 left-0 z-50 w-full h-16 bg-gray-800 text-white flex justify-between items-center px-4 md:px-8'>
      <div className="flex items-center">
        <Link className='flex items-center gap-2' to="/">
          <img className='w-10' src="/ieli.webp" alt="Logo" />
          <p className='text-xl font-serif'>La Inmaculada</p>
        </Link>
      </div>

      {/* Botón hamburguesa para móviles */}
      <button className='md:hidden' onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Menú normal en pantallas grandes */}
      <ul className='hidden md:flex gap-8 items-center'>
        <li><Link to="/">Inicio</Link></li>
        <li
          ref={dropdownRef}
          className='relative'
          onMouseEnter={() => setShowDropdown(true)}
          onMouseLeave={() => setShowDropdown(false)}
        >
          <button className="flex items-center gap-1 hover:underline">
            Nosotros
            <motion.span animate={{ rotate: showDropdown ? 180 : 0 }} transition={{ duration: 0.2 }}>
              <ChevronDown size={18} />
            </motion.span>
          </button>
          <AnimatePresence>
            {showDropdown && (
              <motion.ul
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
                className='absolute top-8 left-0 bg-gray-700 rounded shadow-md p-2 space-y-1 z-50 w-40'
              >
                <li><Link to="/historia" onClick={() => setShowDropdown(false)}>Historia</Link></li>
                <li><Link to="/logros" onClick={() => setShowDropdown(false)}>Logros</Link></li>
                <li><Link to="/normas" onClick={() => setShowDropdown(false)}>Normas</Link></li>
                <li><Link to="/valores" onClick={() => setShowDropdown(false)}>Valores</Link></li>
                <li><Link to="/personal" onClick={() => setShowDropdown(false)}>Nuestro Personal</Link></li>
              </motion.ul>
            )}
          </AnimatePresence>
        </li>
        <li><Link to="/mision">Misión y Visión</Link></li>
        <li><Link to="/actividades">Actividades</Link></li>
        <li><Link to="/turismo">Zonas Turisticas</Link></li>
      </ul>

      {/* Menú desplegable móvil */}
      {menuOpen && (
        <ul className='md:hidden absolute top-16 left-0 w-full bg-gray-900 p-4 space-y-2 z-40'>
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link></li>
          <li><Link to="/historia" onClick={() => setMenuOpen(false)}>Historia</Link></li>
          <li><Link to="/logros" onClick={() => setMenuOpen(false)}>Logros</Link></li>
          <li><Link to="/personal" onClick={() => setMenuOpen(false)}>Nuestro Personal</Link></li>
          <li><Link to="/normas" onClick={() => setMenuOpen(false)}>Normas</Link></li>
          <li><Link to="/mision" onClick={() => setMenuOpen(false)}>Misión y Visión</Link></li>
          <li><Link to="/actividades" onClick={() => setMenuOpen(false)}>Actividades</Link></li>
          <li><Link to="/ubicanos" onClick={() => setMenuOpen(false)}>Ubicanos</Link></li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
